// extracted by mini-css-extract-plugin
export var textWithSubheading = "styles-module--textWithSubheading--w-aG7";
export var titleContainer = "styles-module--titleContainer--xB+4w";
export var noContainer = "styles-module--noContainer--RJ0sD";
export var enableTopBorder = "styles-module--enableTopBorder--nOoZf";
export var enableBottomBorder = "styles-module--enableBottomBorder--LxfWe";